import DateTime from "Utils/DateTime";

const TaskResFormatter: (data: any) => any = (data) => {
  return {
    actualDeviceId: data?.actualDeviceId,
    assigneeUserId: data?.assigneeUserId,
    assigneeUserName: data?.assigneeUserName,
    createdAt: data?.createdAt,
    createdBy: data?.createdBy,
    createdByName: data?.createdByName,
    deviceType: data?.deviceType,
    groupId: data?.groupId,
    groupName: data?.groupName,
    id: data?.id,
    isDeleted: data?.isDeleted,
    notes: data?.notes,
    patientId: data?.patientId,
    patientName: data?.patientName,
    practiceId: data?.practiceId,
    practiceLocationId: data?.practiceLocationId,
    priority: data?.priority,
    source: data?.source,
    status: data?.status,
    subject: data?.subject,
    targateDate: DateTime.UTCToLocalDateTime(data?.targateDate),
    taskDescription: data?.taskDescription,
    type: data?.type,
  };
};

export default {
  TaskResFormatter,
  ///New and checked funtions
};
